import { render, staticRenderFns } from "./CityInfo.vue?vue&type=template&id=541d4a94&scoped=true&"
import script from "./CityInfo.vue?vue&type=script&lang=js&"
export * from "./CityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d4a94",
  null
  
)

export default component.exports